import { SsPage } from 'src/js/dom/page.js';
import { SsSubPage } from 'src/js/dom/sub-page.js';
import { SsPathFinder } from 'src/js/dom/path-finder.js';
import { SsBack } from 'src/js/dom/back.js';
import { scroller } from 'src/js/lib/scroll.js';
import { getScroll } from 'src/js/lib/offset.js';
import {
  getHash,
  getPathFinder,
} from 'src/js/lib/url.js';

export default function () {
  const mainPage = new SsPage(
    document.getElementById( 'ss-main-page' )
  );
  const subPage = new SsSubPage(
    document.getElementById( 'ss-sub-page' )
  );
  const paths = Array.prototype.map.call(
    document.querySelectorAll( '.path-finder' ),
    elm => new SsPathFinder( elm )
  );
  const pathBacks = Array.prototype.map.call(
    document.querySelectorAll( '.path-finder-back' ),
    elm => new SsPathFinder( elm )
  );
  const backBtn = new SsBack(
    document.getElementById( 'ss-gallery-back' ),
    document.getElementById( 'ss-tgt-back' )
  );

  let lastScroll = undefined;

  const pathInstances = {};

  paths.forEach( path => {
    pathInstances[ path.getData( 'id' ) ] = path;
  });

  // Initial url check
  const hash = getHash();
  if ( hash ) {
    const pathElm = getPathFinder( hash );
    const path = pathInstances[ hash ];
    if ( pathElm && path ) {
      lastScroll = getScroll().y;
      mainPage.close();
      subPage.setTitle( path.getTitle() );
      subPage.loadLooks(
        hash,
        path.getData( 'path' ),
        Number( path.getData( 'num' ) )
      );
      scroller( 0 );
      subPage.open();
      backBtn.watch();
    }
  }

  // Path finder clicked
  for ( let [ id, path ] of Object.entries( pathInstances ) ) {
    path.onClick();
    path.on( 'path:click', () => {
      lastScroll = getScroll().y;
      mainPage.close();
      subPage.setTitle( path.getTitle() );
      subPage.loadLooks(
        id,
        path.getData( 'path' ),
        Number( path.getData( 'num' ) )
      );
      scroller( 0 );
      subPage.open();
      backBtn.watch();
    });
  }

  // Path back clicked
  for ( let path of pathBacks ) {
    path.onClick();
    path.on( 'path:click', () => {
      backBtn.blind().close();
      subPage.close();
      subPage.reset();
      ( typeof lastScroll !== 'undefined' )
        ? scroller( lastScroll )
        : void 0;
      mainPage.open();
    })
  }
}
